import styled, { css } from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  color?: string;
}

interface ImageProps {
  isDisplay?: boolean;
}

interface MultimediaProps {
  isDisplayImage?: boolean;
  height?: string;
}

export const Multimedia = styled.div`
  max-width: 286px;
  height: 152px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid ${COLORS.GRAY_PLACEHOLDER};
  overflow: hidden;
  position: relative;
  ${(props: MultimediaProps) => props.isDisplayImage ? `
    background: #fff;
  `:`
    background: #F0F0F0;
  `}

  @media (min-width: ${SIZE.TABLET_BREAK}) {
    ${(props: MultimediaProps) => props.height && css`
      height: ${props.height};
    `}
  }
`;

export const Uploader = styled.label`
  overflow: hidden;
  color: #fff;
  width: 119px;
  height: 44px;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  font-weight: 600;
  font-family: ${FONTS.OPEN_SANS};
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 9px;
  background: ${(props: Props) => props.color ? props.color : COLORS.GRAY_PLACEHOLDER};

  input {
    position: absolute;
    visibility: hidden;
  }
`;

export const TextButton = styled.p``;

export const Price = styled.span`
  display: block;
  font-size: 12px;
  text-align: center;
`;

export const IconCloseWrapper = styled.span`
  background: ${(props: Props) => props.color ? props.color : COLORS.GRAY_PLACEHOLDER};
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;

  svg {
    margin: auto;
  }
`;

export const Loading = styled.span`
  right: 0;
  z-index: 10;
  svg{
    fill: transparent;
    stroke-width: 5px;
    stroke: #b7b0b0;
    stroke-dasharray: 100%;
    animation: rotate .5s linear infinite;
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`

export const ImagePreview = styled.img`
  width: auto;
  height: 100%;
  ${(props: ImageProps) => props.isDisplay ? `
    display: inline-block;
  `:`
    display: none;
  `}
`;

export const ErrorMessage = styled.span`
  color: ${COLORS.RED_ERROR};
`;

